const tabbedContentAreas = document.querySelectorAll('.c-tab-content');
if(tabbedContentAreas.length > 0) {
  const tabbedSwiperConfig = {
    slidesPerView: 1.2,
    spaceBetween: 20,
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      992: {
        slidesPerView: 3,
      }
    }
  };

  tabbedContentAreas.forEach(contentArea => {
    const tabbedSliders = contentArea.querySelectorAll('.c-slider');
    tabbedSliders.forEach(slider => {
      new Swiper(slider, {
        ...tabbedSwiperConfig,
        navigation: {
          nextEl: contentArea.querySelector('.c-slider-arrow.next'),
          prevEl: contentArea.querySelector('.c-slider-arrow.prev'),
        },
      });
    });
  });


  // TAB/ACCORDION
  const tabButtons = document.querySelectorAll('.c-tab-button');
  const accordionHeaders = document.querySelectorAll('.c-accordion-header');
  const tabContents = document.querySelectorAll('.c-tab-content');
  function switchTab(tabNumber) {
    // REMOVE ACTIVE CLASS FROM ALL
    tabButtons.forEach(btn => btn.classList.remove('active'));
    accordionHeaders.forEach(header => header.classList.remove('active'));
    tabContents.forEach(content => content.classList.remove('active'));

    // ADD ACTIVE CLASS TO SELECTED
    document.querySelector(`.c-tab-button[data-tab="${tabNumber}"]`)?.classList.add('active');
    document.querySelector(`.c-accordion-header[data-tab="${tabNumber}"]`)?.classList.add('active');
    document.querySelector(`.c-tab-content[data-tab="${tabNumber}"]`)?.classList.add('active');
  }

  // DESKTOP TAB CLICKS
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      switchTab(button.getAttribute('data-tab'));
    });
  });

  // MOBILE ACCORDION CLICKS
  accordionHeaders.forEach(header => {
    header.addEventListener('click', () => {
      const tabNumber = header.getAttribute('data-tab');
      const isActive = header.classList.contains('active');
      if (isActive) {
        // CLOSE IF ALREADY OPEN
        header.classList.remove('active');
        document.querySelector(`.c-tab-content[data-tab="${tabNumber}"]`).classList.remove('active');
      } else {
        // OPEN SELECTED
        switchTab(tabNumber);
      }
    });
  });
}